import { HttpErrorResponse } from '@angular/common/http';
import {
  catchError,
  defer,
  EMPTY,
  exhaustMap,
  filter,
  Observable,
  pairwise,
  retry,
  take,
  throwError,
  timer,
} from 'rxjs';
import { RefreshTokenStateService } from './refresh-token-state.service';

export function pollResumingAfterTokenRefresh<T>(
  intervalMs: number,
  request: (passive: boolean) => Observable<T>,
  refreshTokenState: RefreshTokenStateService | null
): Observable<T> {
  const refreshFinished$ = refreshTokenState
    ? refreshTokenState.refreshTokenInProgress$.pipe(
        pairwise(),
        filter(
          ([wasInProgress, isInProgress]) => wasInProgress && !isInProgress
        ),
        take(1)
      )
    : EMPTY;

  return defer(() => {
    let resumed = false;

    return timer(0, intervalMs).pipe(
      exhaustMap(tick =>
        request(resumed || tick > 0).pipe(
          catchError((error: unknown) =>
            error instanceof HttpErrorResponse && error.status === 401
              ? throwError(() => error)
              : EMPTY
          )
        )
      ),
      retry({
        delay: () => {
          resumed = true;
          return refreshFinished$;
        },
      })
    );
  });
}
